import type { FC } from 'react';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { AlertCircleFilled } from '@eqi-investimentos/icons/web';
import { Flex, Text } from '@eqi-investimentos/react';
import { PATHS } from '@/config/paths';
export const NoDataImmobilizedList: FC = () => {
  const {
    t
  } = useTranslation('common');
  return <Flex flexDir="column" justifyContent="center" gap="1.25rem" w="full" minH="9.375rem" data-sentry-element="Flex" data-sentry-component="NoDataImmobilizedList" data-sentry-source-file="index.tsx">
      <Flex w="full" maxW="29.375rem" minH="3.75rem" gap="5" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <AlertCircleFilled w="24" h="24" color="content.brand" data-sentry-element="AlertCircleFilled" data-sentry-source-file="index.tsx" />
        <Flex w="full" flexDir="column" gap="2" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          <Text fontSize="sm" lineHeight="m" fontWeight="bold" color="content.primary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
            {t(`screens.financialPlanning.myNetWorth.sectionImmobilized.empty.title`)}
          </Text>
          <Text fontSize="sm" lineHeight="m" color="content.secondary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
            {t(`screens.financialPlanning.myNetWorth.sectionImmobilized.empty.description`)}
          </Text>
        </Flex>
      </Flex>

      <Flex as={Link} href={PATHS.financialPlanning.immobilized} aria-label="button-send-opportunity" justifyContent="center" alignItems="center" gap="2" w="15.5rem" h="2.75rem" bgColor="content.brand" border="none" rounded="0.25rem" transition="background-color 0.2s ease-in-out" sx={{
      _hover: {
        bgColor: 'brand.300'
      }
    }} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Text fontSize="sm" fontWeight="normal" color="content.inverse" data-sentry-element="Text" data-sentry-source-file="index.tsx">
          {t(`screens.financialPlanning.myNetWorth.sectionImmobilized.empty.action`)}
        </Text>
      </Flex>
    </Flex>;
};
export const SENT_NOIMOBILIZED_COOKIE_KEY = 'fp-noimobilized-sent';